import { Helmet } from "react-helmet-async";

const SITE_URL = "https://nkbridalaustralia.com.au";
const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

/**
 * Per-page SEO tags for NK Bridal Australia.
 * Perth = primary location, Brisbane = heritage/origin + regular visits.
 */
export const Seo = ({ title, description, path = "/", image = OG_IMAGE }) => {
  const canonical = `${SITE_URL}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="NK Bridal Australia" />
      <meta property="og:locale" content="en_AU" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default Seo;
